__turbopack_context__.v({
  "curencyText": "styles-module-scss-module__diMmXa__curencyText",
  "currency": "styles-module-scss-module__diMmXa__currency",
  "icon": "styles-module-scss-module__diMmXa__icon",
  "root": "styles-module-scss-module__diMmXa__root",
  "shopLink": "styles-module-scss-module__diMmXa__shopLink",
});
